<template>
    <div ref="new_template">
        <ErrorMessages :errors="errors" :description="$t('ui.general.error')" :is_closable="true"></ErrorMessages>
        <div v-if="is_initialized">
            <table class="ui fixed table blue">
                <thead>
                    <tr>
                        <th class="right aligned">
                            <h3 class="ui header">{{ index_item[title_attribute] }}</h3>
                        </th>
                        <th colspan="4">
                        </th>
                        <th>
                        </th>
                    </tr>
                </thead>
                <tbody class="ui form">
                    <tr v-for="column in columns">
                        <td class="right aligned">
                            {{ column.human_name }}
                        </td>
                        <td colspan="5" style="overflow: visible;">
                            <input type="text" v-model="index_item[column.attribute_name]" :placeholder="column.placeholder" v-if="column.type == 'text'">
                            <input type="number" v-model="index_item[column.attribute_name]" :placeholder="column.placeholder" v-if="column.type == 'number'">
                            <textarea v-model="index_item[column.attribute_name]" :placeholder="column.placeholder" rows="5" v-if="column.type == 'textarea'"></textarea>
                            <select class="ui dropdown" v-dropdown v-model="index_item[column.attribute_name]" v-if="column.type == 'selection'">
                                <option value="">{{ $t('ui.general.please_select') }}</option>
                                <option v-for="option in column.options" :value="option[column.option_attribute_name]">{{ option[column.option_human_name] }}</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td class="right aligned">
                            {{ $t('ui.general.operate') }}
                        </td>
                        <td colspan="5" style="overflow: visible;">
                            <button class="ui basic positive button" @click.prevent="update_index_item">
                                {{ $t('ui.general.update') }}
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import ErrorMessages from '@toolbox/error_box/main.vue'
export default {
    name: "CRUDTemplatesEdit",
    props: {
        // 標題欄位使用的參數keyname
        title_attribute: String,
        // form內容
        columns: Array,
        // auth
        authentication_token: String,
        // 更新對象的human name
        index_item_name: String,
        // response中代表更新對象的keyname
        api_response_corresponding_name_of_index_item: String,
        // 抓取資料url
        fetch_index_item_url: {
            type: Object,
            default: () => { return {} },
        },
        // 更新資料url
        update_index_item_url: {
            type: Object,
            default: () => { return {} },
        },
        // 更新完成後重新導向url
        after_update_url: {
            type: Object,
            default: () => { return {} },
        },
    },
    data() {
        return {
            is_initialized: false,
            is_loading: false,
            index_item: {},
            errors: [],
        }
    },
    created() {
    },
    mounted() {
        this.init()
    },
    watch: {
    },
    computed: {
    },
    methods: {
        async init() {
            try {
                await new Promise(resolve => {
                    this.is_initialized = false
                    resolve()
                })
                await this.fetch_index_item()
                await new Promise(resolve => {
                    this.is_initialized = true
                    resolve()
                })
            } catch (e) {
                switch (e) {
                    default:
                    console.log("init error: ")
                    console.log(e)
                }
            } finally {
            }
        },
        fetch_index_item() {
            var url = this.convert_url_object(this.fetch_index_item_url)
            this.is_loading = true
            return axios.get(url, {headers: { Authorization: this.authentication_token }})
                .then(response => {
                    if (response.data.status == "success") {
                        this.index_item = response.data[this.api_response_corresponding_name_of_index_item]
                    } else {
                        return Promise.reject(response.data)
                    }
                })
                .catch(error => {
                    if (error.response) {
                        switch (error.response.status) {
                            default:
                            this.errors.push(error.response.status + ' ' + error.response.statusText)
                        }
                        this.$noty.error('取得 ' + this.index_item_name + ' 失敗: ' + error.response.status + ' ' + error.response.statusText)
                    } else if (error.errors) {
                        this.$noty.error('取得 ' + this.index_item_name + ' 失敗: ' + error.errors)
                    } else {
                        this.errors.push(this.$t('ui.general.server_offline'))
                        this.$noty.error(this.$t('ui.general.server_offline'))
                    }
                    return Promise.reject(error)
                })
                .finally(() => {
                    this.is_loading = false
                })
        },
        update_index_item() {
            this.is_loading = true
            this.errors = []
            var params = this.index_item
            var url = this.convert_url_object(this.update_index_item_url)
            return axios.post(url, params, { headers: { Authorization: this.authentication_token }})
                .then(response => {
                    if (response.data.status == "success") {
                        this.index_item = response.data[this.api_response_corresponding_name_of_index_item]
                        this.$noty.success("更新" + this.index_item_name + "成功")
                        this.$router.push(this.convert_url_object(this.after_update_url))
                    } else {
                        return Promise.reject(response.data)
                    }
                })
                .catch(error => {
                    if (error.response) {
                        switch (error.response.status) {
                            default:
                            this.errors.push(error.response.status + ' ' + error.response.statusText)
                        }
                        this.$noty.error('取得 ' + this.index_item_name + ' 失敗: ' + error.response.status + ' ' + error.response.statusText)
                    } else if (error.errors) {
                        this.$noty.error('取得 ' + this.index_item_name + ' 失敗: ' + error.errors)
                        this.errors = response.data.errors
                    } else {
                        this.errors.push(this.$t('ui.general.server_offline'))
                        this.$noty.error(this.$t('ui.general.server_offline'))
                    }
                    return Promise.reject(error)
                })
                .finally(() => {
                    setTimeout(() => {
                        this.is_loading = false
                    }, 300)
                })
        },
        convert_url_object(obj) {
            var params_obj = {}
            for (let param of obj.params) {
                switch (param.source) {
                    case "index_item":
                        params_obj[param.key_name] = this.index_item[param.attribute_name]
                        break
                    case "route_params":
                        params_obj[param.key_name] = this.$route.params[param.attribute_name]
                        break
                }
            }
            switch (obj.type) {
                case "vue":
                    return {
                        name: obj.url,
                        params: params_obj,
                    }
                    break
                case "http":
                    return new RestUrl(obj.url).parse(params_obj)
                    break
            }
        },
    },
    components: {
        ErrorMessages,
    }
}
</script>

<style scoped>
</style>
